<template>
    <div class="no-medias">
        <h2>{{ $TL.noFavoritesFound }}</h2>
    </div>
</template>

<script>
export default {
    name: "no-medias",
    data() {
        return {};
    }
};
</script>

<style lang="scss">
.no-medias {
    h2 {
        text-align: center;
        margin-top: 24vh;
    }
}
</style>
